import { render } from "./loginsimple.vue?vue&type=template&id=36cbe733"
import script from "./loginsimple.vue?vue&type=script&lang=js"
export * from "./loginsimple.vue?vue&type=script&lang=js"

import "./loginsimple.vue?vue&type=style&index=0&id=36cbe733&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__